import { Box } from '@mui/material';
import React from 'react';
import LinkifiedHtml from '../LinkifiedHtml';
import { Palette } from 'Palette';
import { CARD_HEADER_PADDING_BOTTOM, CARD_HEADER_PADDING_TOP } from 'DesignTokens';
import { FONT_INTER, StyledHeading } from '../styles/styles';

/** Title typography shared with the v2 editor's in-place Image Cards title field. */
export const PROPERTY_CARD_TITLE_STYLE = {
  fontFamily: FONT_INTER,
  fontSize: '1rem',
  fontWeight: 600,
  lineHeight: 1.3,
  color: '#1C1C1C',
} as const;

interface PropertyCardHeaderProps {
  mini: boolean;
  tone: keyof typeof Palette;
  processedTitle: string | undefined;
  derivedTitle: string | undefined;
  footnotes: import('../../models/TopLevelTemplateComponentProps').FootNoteProps[] | undefined;
  forceTitleSpacing: boolean;
  hasUnreadUpdates: boolean | undefined;
}

export default function PropertyCardHeader({
  mini,
  tone,
  processedTitle,
  derivedTitle,
  footnotes,
  forceTitleSpacing,
  hasUnreadUpdates,
}: PropertyCardHeaderProps) {
  const headingSx = { ...PROPERTY_CARD_TITLE_STYLE, pb: 0, pt: 0 };

  return (
    <Box
      sx={{
        px: mini ? 1.5 : 2,
        pt: mini ? CARD_HEADER_PADDING_TOP.mini : CARD_HEADER_PADDING_TOP.default,
        pb: mini ? CARD_HEADER_PADDING_BOTTOM.mini : CARD_HEADER_PADDING_BOTTOM.default,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {forceTitleSpacing && !derivedTitle?.trim() ? (
            <StyledHeading
              headerVariant={mini ? 'heading2' : 'subheading'}
              tone={tone}
              display="inlineBlock"
              component="div"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              sx={headingSx}
              dangerouslySetInnerHTML={{ __html: '&nbsp;' }}
            />
          ) : footnotes && processedTitle !== derivedTitle ? (
            <LinkifiedHtml
              as={StyledHeading}
              headerVariant={mini ? 'heading2' : 'subheading'}
              tone={tone}
              display="inlineBlock"
              component="div"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              sx={headingSx}
              html={processedTitle || ''}
            />
          ) : (
            <StyledHeading
              headerVariant={mini ? 'heading2' : 'subheading'}
              tone={tone}
              display="inlineBlock"
              component="div"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              sx={headingSx}
            >
              {processedTitle}
            </StyledHeading>
          )}
        </Box>
        {hasUnreadUpdates && (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: 'primary.main',
              flexShrink: 0,
            }}
          />
        )}
      </Box>
    </Box>
  );
}
